import React from "react";
import { FastField, Formik, Form } from "formik";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import AppInput from "components/Input/AppInput";
import { Box, FormGroup, makeStyles } from "@material-ui/core";
import AppButton from "components/CustomButtons/AppButton";
import AppColor from "utilities/AppColor";
import * as Yup from "yup";
import { YupValidations } from "utils/validate";

const styles = makeStyles(() => ({
  title: {
    display: 'flex',
    margin: '2rem 0 1rem 0'
  },
  control: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  pinkInput: {
    '& #content': {
      borderColor: AppColor.pink,
      color: AppColor.pink,
      overflow: 'hidden',
      '&::placeholder': {
        color: AppColor.pink,
        opacity: 1
      },
      '&:-ms-input-placeholder': {
        color: AppColor.pink
      },
      '&::-ms-input-placeholder': {
        color: AppColor.pink
      }
    },
    '& label': {
      color: AppColor.pink,
      fontWeight: 700
    }
  }
}));

const AdminFeedbackForm = (props) => {
  const {
    onSubmit,
    isSubmitting,
    display,
    isWorker,
    isCompany,
    feedback = {}
  } = props;

  const { t } = useTranslation();
  const classes = styles();

  const {
    content,
    id: feedbackId
  } = feedback;

  const validationSchema = Yup.object().shape({
    content: YupValidations.requiredString
  });


  const handleSubmitForm = (form) => {
    const params = {
      ...form,
      feedbackId
    };
    onSubmit(params);
  };

  return (
    <Formik
      enableReinitialize={true}
      onSubmit={handleSubmitForm}
      initialValues={{
        content: content ? content : ''
      }}
      validationSchema={validationSchema}
    >
      {() => {
        return (
          <Form className={`${classes.container} ${!display && 'hidden'}`}>
            <Box>
              <FastField
                component={AppInput}
                className={classes.pinkInput}
                name="content"
                label="label.adminFeedback"
                placeholder={`${isCompany ? "text.feedbackToCompany" :isWorker ? "text.feedbackToWorker" : "text.feedbackToClient"}`}
                type="textarea"
                disabled={!onSubmit}
              />
            </Box>
            {
              !!onSubmit && (
                <FormGroup className={classes.control}>
                  <AppButton
                    label={`${feedbackId ? t("button.unReject") : t("button.reject")}`}
                    buttonColor={feedbackId ? AppColor.mainColor : AppColor.pink}
                    type="submit"
                    isLoading={isSubmitting}
                    disabled={isSubmitting}
                  />
                </FormGroup>
              )
            }
          </Form>
        );
      }}
    </Formik>
  );
};

AdminFeedbackForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  isWorker: PropTypes.bool,
  display: PropTypes.bool,
  workerDetail: PropTypes.any,
  changeProgressStatus: PropTypes.func,
  feedback: PropTypes.any,
  isCompany: PropTypes.bool
};

export default AdminFeedbackForm;
